import DataFromBackend from '../../common/configuration/DataFromBackend'

/**
 * Tells whether the legal notes of a promotion have something to show: the CMS
 * saves an emptied editor as an empty paragraph.
 *
 * @param legalNotes Legal notes of the promotion (`tooltip_text`)
 * @returns `true` when there is content to show
 */
export function hasLegalNotes(legalNotes: string | null | undefined): boolean {
    const notes = legalNotes?.trim()

    return Boolean(notes) && notes !== DataFromBackend.EMPTY_PARAGRAPH
}
